export const INITAL_SENSORS = {
  hubId: null,
  hub: null,
  devices: [
    {
      defaultName: "SquidZigBee",
      name: "SquidZigBee",
      displayName: "Lilli hub",
      image: "/images/installation/hub/hub.png",
      alt: "Lilli hub with power cord attached to the hub",
      video: "/images/installation/videos/hub.webm",
      splinePNG: "/images/installation/spline/hub.png",
      online: false,
      eui: "0015BC002C11256E",
      label: "h1",
      id: 0,
    },
    {
      defaultName: "Smart Plug Mini UK",
      name: "Kitchen/Appliance/Power",
      displayName: "Smart plug",
      online: false,
      label: "p1",
      image: "/images/installation/smart_plug/plug.png",
      video: "/images/installation/videos/plug.webm",
      splinePNG: "/images/installation/spline/plug.png",
      id: 6,
      locationRequired: true,
      locationOptions: [
        { value: "Kettle", label: "Kettle" },
        { value: "Microwave", label: "Microwave" },
        { value: "Toaster", label: "Toaster" },
        { value: "Other", label: "Other" },
      ],
    },
    {
      defaultName: "Motion Sensor Mini",
      name: "Hall/Wall/Motion",
      displayName: "Motion sensor",
      image:
        "/images/installation/motion/motion_sensor_battery_high_contrast.png",
      video: "/images/installation/videos/motion.webm",
      splinePNG: "/images/installation/spline/motion.png",
      online: false,
      label: "m1",
      locationRequired: true,
      locationOptions: [
        { value: "Hallway", label: "Hallway" },
        { value: "Stairs", label: "Stairs" },
        { value: "Living Room", label: "Living Room" },
        { value: "Kitchen", label: "Kitchen" },
        { value: "Other", label: "Other" },
      ],
      id: 1,
    },
    {
      defaultName: "Motion Sensor Mini",
      name: "Bathroom/Wall/Motion",
      displayName: "Bathroom sensor",
      online: false,
      image:
        "/images/installation/motion/motion_sensor_battery_high_contrast.png",
      video: "/images/installation/videos/motion.webm",
      splinePNG: "/images/installation/spline/motion.png",
      locationRequired: true,
      locationOptions: [
        { value: "Bath/Shower and Toilet", label: "Bath/Shower and Toilet" },
        { value: "Bath/Shower only", label: "Bath/Shower only" },
        { value: "Toilet only", label: "Toilet only" },
      ],
      label: "m2",
      id: 2,
    },
    {
      defaultName: "Motion Sensor Mini",
      name: "Bedroom/Wall/Motion",
      displayName: "Bedroom sensor",
      online: false,
      description:
        "The sensor should be placed facing the entrance/exit to the bedroom and not facing the bed. It can be placed outside the bedroom.",
      image:
        "/images/installation/motion/motion_sensor_battery_high_contrast.png",
      video: "/images/installation/videos/motion.webm",
      splinePNG: "/images/installation/spline/motion.png",
      label: "m3",
      id: 3,
      locationRequired: true,
      locationOptions: [
        {
          value: "Inside bedroom, facing the entrance",
          label: "Inside bedroom, facing the entrance",
        },
        {
          value: "Outside bedroom, facing entrance",
          label: "Outside bedroom, facing entrance",
        },
        {
          value: "Facing the bed (not recommended)",
          label: "Facing the bed (not recommended)",
        },
        { value: "Other", label: "Other" },
      ],
    },
    {
      defaultName: "Window Sensor",
      name: "Hall/Main/Door",
      displayName: "Main door sensor",
      online: false,
      label: "d1",
      video: "/images/installation/videos/door.webm",
      splinePNG: "/images/installation/spline/door.png",
      id: 4,
      locationRequired: true,
      locationOptions: [
        { value: "Front door", label: "Front door" },
        { value: "Back door", label: "Back door" },
      ],
    },
    {
      defaultName: "Window Sensor",
      name: "Kitchen/Fridge/Door",
      displayName: "Fridge sensor",
      video: "/images/installation/videos/door.webm",
      splinePNG: "/images/installation/spline/door.png",
      online: false,
      label: "d2",
      locationRequired: true,
      locationOptions: [
        { value: "Fridge", label: "Fridge" },
        { value: "Cupboard", label: "Cupboard" },
        { value: "Other", label: "Other" },
      ],
      id: 5,
    },
  ],
};
